import {createReducer, on} from '@ngrx/store';
import {userAuthenticated} from '../actions/auth.action';

const INITIAL_STATE = {
  userAuthenticated: {}
};

export const reducer = createReducer(
  INITIAL_STATE,
  on(userAuthenticated, (state, action: any) => ({ ...state, userAuthenticated: action.payload })),
);
